"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECTED_BORDER = exports.ACCENT_BORDER = exports.ACTIVE_BORDER = exports.DEFAULT_BORDER = exports.WIDTH = exports.RADIUS = exports.RADIUS_DEFAULT = exports.RADIUS_ROUND = exports.RADIUS_XL = exports.RADIUS_LG = exports.RADIUS_MD = exports.RADIUS_SM = void 0;
var polished_1 = require("polished");
var color_1 = require("../color");
exports.RADIUS_SM = (0, polished_1.rem)(2);
exports.RADIUS_MD = (0, polished_1.rem)(4);
exports.RADIUS_LG = (0, polished_1.rem)(8);
exports.RADIUS_XL = (0, polished_1.rem)(12);
exports.RADIUS_ROUND = '50%';
exports.RADIUS_DEFAULT = exports.RADIUS_MD;
exports.RADIUS = {
    SMALL: exports.RADIUS_SM,
    DEFAULT: exports.RADIUS_MD,
    MEDIUM: exports.RADIUS_MD,
    LARGE: exports.RADIUS_LG,
    XLARGE: exports.RADIUS_XL,
    ROUND: exports.RADIUS_ROUND,
};
exports.WIDTH = (0, polished_1.rem)(1);
exports.DEFAULT_BORDER = "".concat(exports.WIDTH, " solid ").concat(color_1.GREY.LIGHT);
exports.ACTIVE_BORDER = "".concat(exports.WIDTH, " solid ").concat(color_1.UTILITY.ACTION);
exports.ACCENT_BORDER = "0.125rem solid ".concat(color_1.UTILITY.ACTION);
exports.SELECTED_BORDER = "".concat(exports.WIDTH, " solid ").concat(color_1.BLUE['300']);
//# sourceMappingURL=index.js.map